// extracted by mini-css-extract-plugin
export default {"container":"Validation_container__OR4DT","teamContainer":"Validation_teamContainer__wAD+k","confirmButton":"Validation_confirmButton__Nxzqw"};